import React, { createContext, useContext } from 'react';
import { Platform, Text as NativeText, type TextProps, type TextStyle, type StyleProp } from 'react-native';
import { appearanceTextStyle } from '../components/AppearanceText';
import { AppearancePreviewContext, AppearanceTypographyContext } from '../theme/AppearanceContext';
import { appearanceFontFamily } from '../theme/appearance';

export type ElementTypography = { fontFamily?: 'system' | 'serif' | 'monospace'; fontSize?: number; fontWeight?: TextStyle['fontWeight']; lineHeight?: number; letterSpacing?: number; color?: string };
export const ElementTypographyContext = createContext<Record<string, ElementTypography>>({});
export function elementTextStyle(value: ElementTypography = {}): TextStyle {
  const { fontFamily, ...style } = value;
  return { ...style, ...(fontFamily ? { fontFamily: appearanceFontFamily(fontFamily) ?? (Platform.OS === 'ios' ? 'System' : Platform.OS === 'web' ? 'system-ui' : 'sans-serif') } : {}) };
}
/** Semantic IDs survive layout reordering and are shared by native and web. */
export function EditableText({ element, style, studioStyle, ...props }: TextProps & { element: string; studioStyle?: StyleProp<TextStyle>; dataSet?: Record<string, string> }) {
  const values = useContext(ElementTypographyContext);
  const typography = useContext(AppearanceTypographyContext);
  const preview = useContext(AppearancePreviewContext);
  const marker = Platform.OS === 'web' ? { dataSet: { ...props.dataSet, studioElement: props.dataSet?.studioElement || element } } : {};
  return <NativeText {...props} {...marker} style={[appearanceTextStyle(style, preview?.typography || typography), elementTextStyle(values[element]), studioStyle]} />;
}
